<template>
  <div class="block_center">
    <div class="banner" :style="{ height: bannerHeight }">
      <el-carousel trigger="click" :height="bannerHeight">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img
            :src="item.imgSrc"
            :loading="index === 0 ? 'eager' : 'lazy'"
            :fetchpriority="index === 0 ? 'high' : 'low'"
            decoding="async"
            alt=""
            @click="clickBanner(item)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 产品优势 -->
    <div class="productAdvantage">
      <div class="intro">
        <div class="introText">{{ $t("home.productAdvantage") }}</div>
        <div class="introDes"></div>
      </div>
      <div class="productList">
        <div
          class="productItem"
          v-for="item in productAdvantageList"
          :key="item.title"
          @mouseenter="hoverItemId = item.title"
          @mouseleave="hoverItemId = null"
          @click="toproduct(item)"
        >
          <div
            class="hoverEffect"
            v-if="item.title && hoverItemId === item.title"
            :style="{ left: item.left, top: item.top }"
          >
            <div class="title">{{ $i18n.locale === "zh" ? item.title : item.titleEn || item.title }}</div>
            <div class="title">{{ item.familyCode }}</div>
            <div class="intros">
              {{ $i18n.locale === "zh" ? item.des : item.desEn || item.des }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业应用 -->
    <div class="productSys" ref="productSys" id="productSys">
      <div class="sysHeader">
        <div class="sysTitle">{{ $t("home.productIntro") }}</div>
        <div class="sysTabs">
          <span
            v-for="(tab, index) in industryTabs"
            :key="index"
            :class="['tabItem', { active: currentTab === tab.id }]"
            @click="switchTab(tab)"
          >
            {{ tab.name }}
          </span>
        </div>
      </div>

      <div
        class="sysContentWai"
        :style="productSysBackgroundStyle"
      >
        <div class="sysContent">
          <div class="contentLeft">
            <div
              v-for="(item, index) in productIntroList"
              :key="index"
              :class="['menuItem', { active: currentMenuItem === item.id }]"
              @click="selectMenuItem(item)"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="contentRight">
            <div class="rightInfo" v-if="currentItemDetail">
              <h2 class="infoTitle" v-html="currentItemDetail.subTitle"></h2>
              <p class="infoDesc" v-html="currentItemDetail.content"></p>
              <button class="detailBtn" @click="toLookMore(currentItemDetail)">
                {{ $t("home.ViewDetails") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="sysFooter">
        <div class="statsGroup">
          <div style="display: flex">
            <div class="statDivider"></div>
            <div class="statItem">
              <span class="statNum">50<sup>+</sup></span>
              <span class="statLabel">{{ $t("home.IPR") }}</span>
            </div>
          </div>
          <div style="display: flex">
            <div class="statDivider"></div>
            <div class="statItem">
              <span class="statNum">11<sup>+</sup></span>
              <span class="statLabel">{{ $t("home.patent") }}</span>
            </div>
          </div>
          <div style="display: flex">
            <div class="statDivider"></div>
            <div class="statItem">
              <span class="statNum">40%<sup>+</sup></span>
              <span class="statLabel">{{ $t("home.Ratio") }}</span>
            </div>
          </div>
        </div>
        <div class="footerRight">
          <div class="footerText">
            <p>{{ $t("home.requirement") }}</p>
            <p>{{ $t("home.solutions") }}</p>
          </div>
          <button class="tryBtn" @click="toFree">
            {{ $t("Buy.freeUse") }}
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="indexMore">
      <div class="moreText">{{ $t('home.getServices') }}</div>
      <div class="moreBtn" @click="toLookMore">{{ $t('home.clickButton') }}</div>
    </div> -->

  </div>
</template>

<script>
import {
  checkPerhomeTopMgrmit,
  productAdvantage,
  industryType,
  industryApplications,
} from "@/assets/API/home.js";
import define from "@/utils/define";
const baceUrl = define.APIURl;

export default {
  components: {},
  data() {
    return {
      bannerHeight: "560px",
      bannerList: [],
      productIntroList: [],
      hoverItemId: null,
      productAdvantageList: [
        {
          title: "峰岭一站式智能成图平台",
          titleEn: "Summit One-Stop Intelligent Mapping Platform",
          familyCode: "SummitMap",
          left: "48%",
          top: "75%",
          des: "集成丰富测图模式、全方位测图功能，真正实现内外业一体、采编一体、图库一体的矢量成图作业。",
          desEn:
            "Integrates rich mapping modes and full-featured surveying workflows to deliver true end-to-end vector production across field and office, collection and editing, and map-database integration.",
        },
        {
          title: "峰岭一站式单体化处理系统",
          titleEn: "Summit One-Stop Monomer Processing System",
          familyCode: "SummitSolid",
          left: "60%",
          top: "40%",
          des: "以真三维几何引擎为核心，集直观三维建模单体化与快速航测法单体化为一体，专注实景三维模型单体化处理和模型修编。",
          desEn:
            "Powered by a true 3D geometric engine, it combines intuitive 3D monomer modeling with rapid aerial-survey monomer workflows, focused on real-scene 3D model segmentation and revision.",
        },
        {
          title: "峰岭地形编辑处理系统",
          titleEn: "Summit Terrain Editing System",
          familyCode: "SummitTerra",
          left: "35%",
          top: "48%",
          des: "集全面、智能化的专业DEM编辑功能于一体，叠加点云、倾斜三维模型以及立体像对等多种数据源，实现平面与立体模式下的规模化DEM协同编辑生产，高效、精准还原地形地貌。",
          desEn:
            "Combines comprehensive and intelligent professional DEM editing with multiple data sources including point clouds, oblique 3D models, and stereo pairs to enable large-scale collaborative DEM production in both planar and stereoscopic modes, accurately restoring terrain.",
        },
        {},
        {},
        {
          title: "峰岭多源数据智能处理平台",
          titleEn: "Summit Multi-Source Data Intelligent Processing Platform",
          familyCode: "SummitPixel",
          left: "20%",
          top: "55%",
          des: "一站式覆盖遥感影像空三解算、正射纠正、影像融合、匀光匀色、镶嵌成图的整个流程，利用先进图像处理技术，一键高效生成数字正射影像图DOM与数字表面模型DSM成果。",
          desEn:
            "One-stop coverage of the full remote-sensing workflow including aerial triangulation, orthorectification, image fusion, color balancing, and mosaicking, enabling one-click efficient generation of DOM and DSM outputs with advanced image-processing technology.",
        },
        {
          title: "峰岭航测内业智能化培训系统",
          titleEn: "Summit Intelligent Photogrammetry Training System",
          familyCode: "SummitLab",
          left: "40%",
          top: "18%",
          des: "专为航测内业教学量身定制，集在线学习、仿真实践、课后考核等功能于一体，通过专业定量化交互培训，学员2个月即可上图。",
          desEn:
            "Tailored for photogrammetry office-work training, integrating online learning, simulation practice, and post-class assessment. With professional quantitative interactive training, trainees can begin production mapping in about two months.",
        },
        {
          title: "峰岭空间数据生产管理系统",
          titleEn: "Summit Spatial Data Production Management System",
          familyCode: "FlowSummit",
          left: "32%",
          top: "25%",
          des: "专为地理信息项目的全生命周期管理与精细化风险控制设计，实现项目质量与全角色效能的双提升。",
          desEn:
            "Purpose-built for geospatial projects across the full lifecycle with refined risk control, improving both project quality and cross-role efficiency.",
        },
        {
          title: "峰岭空间数据硬盘管理系统",
          titleEn: "Summit Spatial Data Disk Management System",
          familyCode: "DiskSummit",
          left: "30%",
          top: "35%",
          des: "对海量空间地理信息数据进行高效存储、智能归档、语义分析及价值挖掘，供生产管理软件无缝调用，并助力实现数据的资产化运营与安全可控的共享交易。",
          desEn:
            "Provides efficient storage, intelligent archiving, semantic analysis, and value mining for massive geospatial datasets, enabling seamless integration with production-management software and supporting secure, controllable data asset operation and sharing.",
        },
      ],
      baceUrl: baceUrl,
      language: this.$i18n.locale,
      // 新增数据
      currentTab: null,
      currentMenuItem: null,
      industryTabs: [],
      currentMenu: null,
      shouldLoadProductSysBg: false,
      productSysObserver: null,
    };
  },
  computed: {
    currentItemDetail() {
      if (this.currentMenuItem !== null && this.currentMenuItem !== undefined) {
        const item = this.productIntroList.find(
          (item) => item.id === this.currentMenuItem
        );
        if (!item || !item.fileData) return null;
        const fileData = JSON.parse(item.fileData);

        return {
          ...item,
          subTitle: this.language == "zh" ? item.subTitle : item.subTitleEn,
          title: this.language == "zh" ? item.title : item.titleEn,
          content: this.language == "zh" ? item.content : item.contentEn,
          imgSrc: fileData[0] ? this.baceUrl + fileData[0]?.url : "",
        };
      }
      return null;
    },
    productSysBackgroundStyle() {
      return {
        backgroundImage:
          this.shouldLoadProductSysBg && this.currentItemDetail?.imgSrc
            ? `url(${this.currentItemDetail.imgSrc})`
            : "none",
      };
    },
  },
  mounted() {
    this.$store.commit("isFull", false);
    window.addEventListener("scroll", this.handleScrollSidebar);
    window.addEventListener("resize", this.updateBannerHeight);
    this.updateBannerHeight();
    this.getbannerList();
    this.getindustryType();
    this.$nextTick(() => {
      this.initProductSysLazyLoad();
    });
    // this.getProductAdvantage();
  },
  watch: {
    // 监听路由变化
    "$route.query": {
      handler() {
        this.handleRouteParams();
      },
      immediate: false,
    },
  },
  methods: {
    updateBannerHeight() {
      const width = window.innerWidth || 1920;
      // 4K/高分屏下使用自适应高度，避免固定像素导致首屏间距过大
      const adaptiveHeight = Math.round(width * 0.24);
      const finalHeight = Math.max(420, Math.min(720, adaptiveHeight));
      this.bannerHeight = `${finalHeight}px`;
    },

    initProductSysLazyLoad() {
      const target = this.$refs.productSys;
      if (!target || this.shouldLoadProductSysBg) return;

      if (!("IntersectionObserver" in window)) {
        this.shouldLoadProductSysBg = true;
        return;
      }

      this.productSysObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.shouldLoadProductSysBg = true;
            if (this.productSysObserver) {
              this.productSysObserver.disconnect();
              this.productSysObserver = null;
            }
          });
        },
        {
          root: null,
          threshold: 0.05,
          rootMargin: "300px 0px",
        }
      );

      this.productSysObserver.observe(target);
    },

    handleRouteParams() {
      const { scrollTo, tabId } = this.$route.query;
      console.log("路由参数", scrollTo, tabId);

      if (scrollTo === "productSys") {
        // 延迟执行，确保DOM已渲染
        this.$nextTick(() => {
          setTimeout(() => {
            const element = this.$refs.productSys;
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        });
      }
      if (tabId) {
        this.currentTab = tabId;
        this.currentMenuItem = 0;
        this.getindustryApplications(tabId);
      }
    },

    switchTab(item) {
      this.currentTab = item.id;
      this.currentMenuItem = 0;
      this.getindustryApplications(item.id);
    },
    selectMenuItem(item) {
      this.currentMenuItem = item.id;
      this.currentMenu = item;
    },
    // 获取banner列表
    getbannerList() {
      checkPerhomeTopMgrmit().then((res) => {
        this.bannerList = res.data.map((item) => {
          const data = JSON.parse(item.fileData);
          return {
            imgSrc: this.baceUrl + data[0].url,
            value: item.pcRelationName,
            code: item.pcRelationCode,
            id: item.pcRelationId,
            relationType: item.pcRelationType,
          };
        });
      });
    },
    // 获取产品介绍列表
    getindustryType() {
      industryType().then((res) => {
        const data = res.data;
        if (!data.length) return;
        this.industryTabs = data.map((item) => {
          return {
            ...item,
            name: this.language == "zh" ? item.name : item.nameEn,
          };
        });
        if (this.$route.query.tabId) {
          this.handleRouteParams();
        } else {
          this.currentTab = this.industryTabs[0].id;
          this.getindustryApplications(this.currentTab);
        }
      });
    },
    // 获取产品介绍列表
    getindustryApplications(id) {
      industryApplications(id).then((res) => {
        const data = res.data;
        if (!data.length) return (this.productIntroList = []);
        this.productIntroList = data.map((item) => {
          return {
            ...item,
            title: this.language == "zh" ? item.title : item.titleEn,
          };
        });
        this.currentMenuItem = this.productIntroList[0]?.id || null;
      });
    },
    //获取产品优势
    getProductAdvantage() {
      productAdvantage().then((res) => {
        this.productAdvantageList = res.data.map((item) => {
          const data = JSON.parse(item.fileData);
          return {
            title: this.language == "zh" ? item.title : item.titleEn,
            des: this.language == "zh" ? item.content : item.contentEn,
            iconUrl: item.iconUrl || "",
            imgSrc: this.baceUrl + data[0].url,
          };
        });
      });
    },
    clickBanner(data) {
      const relationId = data?.id;
      const relationType = String(data?.relationType || "");

      if (!relationId || !relationType) return;
      if (relationType === "1") {
        this.$router.push({
          path: "/AllProducts",
          query: { productId: relationId },
        });
        return;
      }
      if (relationType === "2") {
        this.$router.push({
          path: "/Buy",
          query: {
            familyCode: data?.code || "",
            productId: relationId,
          },
        });
        return;
      }
      if (relationType === "3") {
        this.$router.push({ path: "/NoticeDetail", query: { id: relationId } });
        return;
      }
      if (relationType === "4") {
        this.$router.push({
          path: "/freeSoft",
          query: { softId: relationId },
        });
      }
    },
    toproduct(item) {
      this.$router.push({
        path: "/AllProducts",
        query: {
          familyCode: item.familyCode,
        },
      });
    },
    handleScrollSidebar() {
      const currentScrollPosition = window.scrollY;
      if (currentScrollPosition > this.previousScrollPosition) {
        this.paneFlag = true;
        this.previousScrollPosition = currentScrollPosition;
      } else if (currentScrollPosition < this.previousScrollPosition) {
        this.paneFlag = false;
        this.previousScrollPosition = currentScrollPosition;
      }
    },
    toLookMore(value) {
      // 获取当前选中的tab信息
      const currentTabInfo = this.industryTabs.find(
        (tab) => tab.id === this.currentTab
      );
      const breadcrumbData = {
        ...value,
        productName: value.title,
        tabId: currentTabInfo.id,
        tabName: currentTabInfo.name,
        productId: value.id,
        introduceImg: value.fileData
          ? this.baceUrl + (JSON.parse(value.fileData)?.[0]?.url || "")
          : "",
      };

      sessionStorage.setItem("breadcrumbInfo", JSON.stringify(breadcrumbData));

      // 路由只传必要的 name 参数
      this.$router.push({
        path: "/AllProducts",
        query: {
          name: value.title,
          // productId: value.id,
        },
      });
      // this.$bus.$emit("reloadactivePath", "/AllProducts");
    },
    toFree() {
      this.$router.push({ path: "/Buy" });
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollSidebar);
    window.removeEventListener("resize", this.updateBannerHeight);
    if (this.productSysObserver) {
      this.productSysObserver.disconnect();
      this.productSysObserver = null;
    }
    this.$bus.$off("switchIndustryTab");
  },
};
</script>

<style scoped lang="scss">
.block_center {
  --section-spacing: 60px;
  margin-top: calc(60px + var(--notice-h, 0px));

  .banner {
    width: 100%;
    min-height: 420px;

    ::v-deep .el-carousel,
    ::v-deep .el-carousel__container,
    ::v-deep .el-carousel__item {
      width: 100%;
      height: 100%;
    }
  }
  .el-carousel__item {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      cursor: pointer;
    }
  }

  // 行业应用样式
  .productSys {
    background: linear-gradient(135deg, #3a8ee6 0%, #5ba0e8 50%, #7ab8f5 100%);

    .sysHeader {
      padding: 60px 0 var(--section-spacing);
      text-align: center;
      background: #f7f8fc;

      .sysTitle {
        font-size: 42px;
        font-weight: 600;
        color: #383838;
        margin-bottom: 20px;
      }

      .sysTabs {
        display: flex;
        justify-content: center;
        gap: 60px;

        .tabItem {
          font-size: 18px;
          color: #666;
          cursor: pointer;
          padding-bottom: 8px;
          border-bottom: 2px solid transparent;
          transition: all 0.3s;

          &:hover,
          &.active {
            color: #2b85e5;
            border-bottom-color: #2b85e5;
          }
        }
      }
    }
    .sysContentWai {
      position: relative;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      z-index: 1;
    }

    // /* 核心：给背景图加一层半透明遮罩，实现透明效果 */
    // .sysContentWai::after {
    //   content: "";
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   width: 100%;
    //   height: 100%;
    //   background-color: rgba(42, 126, 216, 0.7);
    //   z-index: -1;
    // }

    .sysContent {
      display: flex;
      align-items: center;
      gap: 24px;
      min-height: 747px;
      position: relative;
      overflow: hidden;
      max-width: 1420px;
      margin: 0 auto;
      padding: 20px 0 40px;

      .contentLeft {
        flex: 0 0 250px;
        width: 250px;
        min-width: 250px;
        padding: 25px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        z-index: 1;
        background-color: rgba(0, 69, 143, 0.3);
        border-radius: 8px;

        .menuItem {
          padding: 12px 20px;
          font-size: 15px;
          color: rgba(255, 255, 255, 0.8);
          cursor: pointer;
          border-radius: 4px;
          transition: all 0.3s;

          &:hover {
            color: #fff;
            background: rgba(255, 255, 255, 0.1);
          }

          &.active {
            color: #333;
            background: #fff;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          }
        }
      }

      .contentRight {
        flex: 1 1 auto;
        min-width: 0;
        padding: 0 25px;
        z-index: 1;
        border-left: 1px solid rgba(255, 255, 255, 0.2);
        margin-left: 0;

        .rightInfo {
          width: 100%;
          max-width: 100%;

          .infoTitle {
            font-size: clamp(24px, 2vw, 32px);
            font-weight: 600;
            color: #fff;
            margin: 10px 0;
            line-height: 1.18;
            word-break: break-word;
          }

          .infoSubtitle {
            font-size: clamp(22px, 1.8vw, 28px);
            font-weight: 500;
            color: #fff;
            margin-bottom: 30px;
            line-height: 1.18;
            word-break: break-word;
          }

          .infoDesc {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.9);
            line-height: 1.8;
            max-width: 600px;
            width: 100%;
            margin-bottom: 30px;
            word-break: break-word;
          }

          .detailBtn {
            padding: 10px 30px;
            font-size: 14px;
            color: #333;
            background: #fff;
            border: none;
            border-radius: 20px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
          }
        }
      }
    }

    .sysFooter {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px 120px;
      background: url("../../assets/image/pay/sysFooterBg.png") no-repeat center;
      background-size: 100% 100%;

      .statsGroup {
        display: flex;
        align-items: center;
        gap: 40px;

        .statItem {
          text-align: center;

          .statNum {
            font-size: 35px;
            color: #fff;

            sup {
              font-size: 24px;
            }
          }

          .statLabel {
            display: block;
            font-size: 18px;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 2px;
          }
        }

        .statDivider {
          width: 12px;
          height: 90px;
          background: url("../../assets/image/dervier.png") no-repeat center;
          background-size: 100% 100%;
        }
      }

      .footerRight {
        display: flex;
        align-items: center;
        gap: 40px;
        margin-left: 40px;

        .footerText {
          text-align: right;

          p {
            font-size: 22px;
            font-weight: 500;
            color: #fff;
            margin: 5px 0;
          }
        }

        .tryBtn {
          padding: 12px 45px;
          font-size: 18px;
          color: #2b85e5;
          background: #fff;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }

    @media screen and (max-width: 1400px) {
      .sysContentWai {
      }

      .sysContent {
        min-height: 640px;
        padding: 24px 16px 36px;
        align-items: stretch;
      }

      .sysContent .contentLeft {
        flex-basis: 220px;
        width: 220px;
        min-width: 220px;
        padding: 20px;
      }

      .sysContent .contentRight {
        padding: 0 18px;
      }

      .sysContent .contentRight .rightInfo .infoTitle {
        font-size: clamp(22px, 2.2vw, 30px);
      }

      .sysContent .contentRight .rightInfo .infoSubtitle {
        font-size: clamp(18px, 1.9vw, 24px);
        margin-bottom: 20px;
      }

      .sysContent .contentRight .rightInfo .infoDesc {
        max-width: 100%;
        line-height: 1.7;
        margin-bottom: 24px;
      }
    }

    @media screen and (max-width: 1200px) {
      .sysContentWai {
      }

      .sysContent {
        flex-wrap: wrap;
        min-height: unset;
      }

      .sysContent .contentLeft {
        flex: 1 1 100%;
        width: 100%;
        min-width: 0;
      }

      .sysContent .contentRight {
        flex: 1 1 100%;
        width: 100%;
        border-left: none;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        margin-top: 10px;
        padding: 18px 0 0;
      }

      .sysContent .contentRight .rightInfo .infoTitle,
      .sysContent .contentRight .rightInfo .infoSubtitle,
      .sysContent .contentRight .rightInfo .infoDesc {
        max-width: 100%;
      }
    }
  }

  // 产品优势样式
  .productAdvantage {
    padding-top: var(--section-spacing);
    height: 950px;
    box-sizing: border-box;

    .intro {
      text-align: center;

      .introText {
        font-size: 48px;
        font-weight: 600;
        color: #383838;
      }

      .introDes {
        font-size: 22px;
        color: #a6a6a6;
        margin: 25px 0;
      }
    }

    .productList {
      max-width: 1300px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      background: url("../../assets/image/未标题-1.png") no-repeat center;
      background-size: 100% 100%;
      height: 734px;

      .productItem {
        position: relative;

        .hoverEffect {
          position: absolute;
          width: 78%;
          border-radius: 8px;
          background-color: rgba(0, 0, 0, 0.55);
          transition: all 0.3s ease-in-out;
          color: #fff;
          padding: 16px;
          box-sizing: border-box;
          cursor: pointer;

          .title {
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
          }
          .intros {
            font-size: 15px;
            line-height: 24px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.indexMore {
  background-image: url("../../assets/image/indexBgBottom.png");
  background-size: 100% 100%;
  height: 400px;
  padding-top: 69px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .moreText {
    font-size: 36px;
    color: #fff;
    text-align: center;
  }

  .moreBtn {
    margin-top: 28px;
    width: 265.98px;
    height: 56.1px;
    border-radius: 30px;
    background: #fff;
    font-size: 24px;
    font-weight: 500;
    line-height: 56.1px;
    color: #2b85e5;
    text-align: center;
    cursor: pointer;
  }
}
</style>
